var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5715 2.85714H11.5344L9.48447 0.808057L10.2858 0L13.7144 3.42857L10.2858 6.85714L9.48447 6.0488L11.5327 4H4.5715C3.66218 4 2.79011 4.36122 2.14713 5.00421C1.50415 5.64719 1.14292 6.51926 1.14292 7.42857C1.14292 8.33789 1.50415 9.20996 2.14713 9.85294C2.79011 10.4959 3.66218 10.8571 4.5715 10.8571H9.14293V12H4.5715C3.35908 12 2.19632 11.5184 1.33901 10.6611C0.481697 9.80375 6.67572e-05 8.64099 6.67572e-05 7.42857C6.67572e-05 6.21615 0.481697 5.05339 1.33901 4.19608C2.19632 3.33877 3.35908 2.85714 4.5715 2.85714Z",
    fill: "#6B54F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/Redo.ee9a9f58.svg";
export { ForwardRef as ReactComponent };